/**
 * **"What this clinic has may have changed"** — fired by the API client when a
 * request is refused with `MODULE_REQUIRED`, so the modules the shell drew from
 * are read again (QA-13). Without it an operator switching a module left an open
 * tab showing the old sidebar until a reload.
 */
export const MODULES_CHANGED = "dentacore:modules-changed";

export function announceModulesChanged(): void {
  window.dispatchEvent(new Event(MODULES_CHANGED));
}
